import React, { useState, useEffect } from 'react';
import api from '../services/api';

export const notificationService = {
  async getSettings() {
    const response = await api.get('/notifications/settings');
    return response.data;
  },

  async updateSettings(payload) {
    const response = await api.put('/notifications/settings', payload);
    return response.data;
  },

  async getLogs(params = {}) {
    const response = await api.get('/notifications/logs', { params });
    return response.data;
  },

  async getLogsSummary() {
    const response = await api.get('/notifications/logs/summary');
    return response.data;
  },

  async triggerManualProcessing() {
    const response = await api.post('/notifications/trigger-manual');
    return response.data;
  },
};
